"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_select_1 = tslib_1.__importDefault(require("react-select"));
exports.SelectBox = props => {
    return (react_1.default.createElement(react_select_1.default, Object.assign({ className: `react-select-container ${props.extraClassName}`, classNamePrefix: "react-select", menuPortalTarget: document.body, styles: { menuPortal: base => (Object.assign(Object.assign({}, base), { zIndex: 1055 })) } }, props, { onChange: (v, actions) => {
            if (props.onChange) {
                props.onChange(props.isMulti && !Array.isArray(v) ? [] : v, actions);
            }
        } })));
};
//# sourceMappingURL=SelectBox.js.map